export default __webpack_public_path__ + "static/media/ezdrowie.78c103e2.svg";